module.exports = __webpack_public_path__ + "img/15_asia.134e0512.png";